import React from 'react';
import { Wrapper, Content, Container } from './elements';
import Sidebar from './SideBar';
import Header from './Header';

const UnauthorizedLayout = (props: React.PropsWithChildren<{}>) => {
	return (
		<Wrapper>
			<Container>
				<Sidebar />
				<div style={{ width: 1020 }}>
					<Header />
					<Content>{props.children}</Content>
				</div>
			</Container>
		</Wrapper>
	);
};

export default UnauthorizedLayout;
